import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-scroll',
  templateUrl: './scroll.component.html'
})
export class ScrollComponent implements OnInit {

  @Input() color = 'white';
  @Input() link;

  constructor() { }

  ngOnInit(): void {
  }

}
